import { render, staticRenderFns } from "./AIDemos.vue?vue&type=template&id=184a8d90&scoped=true&"
import script from "./AIDemos.vue?vue&type=script&lang=js&"
export * from "./AIDemos.vue?vue&type=script&lang=js&"
import style0 from "./AIDemos.vue?vue&type=style&index=0&id=184a8d90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184a8d90",
  null
  
)

export default component.exports